import { StripeEnv } from '../../util/enums';
import { vaultRequest } from './request';

const DOCUMENT_GATEWAY_UPLOAD_MUTATION = `
    mutation VaultDocumentGatewayUpload(
        $gateway: VaultFinancialProvider!,
        $rawDocumentFront: String!,
        $type: VaultRequiredDocument!,
        $vaultId: ID!,
        $rawDocumentBack: String,
        $stripeConnectAccountId: String,
        $stripePersonId: String
        $fileType: String!
        $stripeEnv: VaultStripeEnv
        $unitApplicationId: String
        $unitDocumentId: String
        ) {
      vaultDocumentGatewayUpload(
          gateway: $gateway,
          documentFront: $rawDocumentFront,
          type: $type,
          vaultId: $vaultId,
          documentBack: $rawDocumentBack,
          stripeConnectAccountId: $stripeConnectAccountId,
          stripePersonId: $stripePersonId,
          fileType: $fileType,
          stripeEnv: $stripeEnv,
          unitApplicationId: $unitApplicationId,
          unitDocumentId: $unitDocumentId
          ) {
          success
          errors {
              message
              type
          }
      }
    }
`;

export const uploadDocument = async ({
  stripeEnv,
  documentFront,
  documentBack,
  ...docParams
}: {
  stripeEnv?: StripeEnv;
  gateway: 'stripe' | 'unit';
  documentFront: string;
  type: VaultRequiredDocument;
  vaultId: string;
  documentBack?: string;
  stripeConnectAccountId?: string;
  unitApplicationId?: string;
  stripePersonId?: string;
  fileType: string;
  unitDocumentId?: string;
}): Promise<void> => {
  const documentRes = await vaultRequest(DOCUMENT_GATEWAY_UPLOAD_MUTATION, {
    stripeEnv,
    ...docParams,
    rawDocumentFront: documentFront,
    rawDocumentBack: documentBack,
  });
  const documentData = await documentRes.json();
  if (documentData.errors) {
    throw new Error(documentData.errors);
  }
};
